/* eslint-disable */
import { MDDEResult } from "@sa/rep-mdde";
import { useMemo, useState, useEffect } from "react";
import { async } from "rxjs/internal/scheduler/async";
import {
  OLAPTransformer,
  OLAPTransformerOptions,
  OLAPTransformerQuery,
  OLAPTransformerResult,
} from "../OLAPTransformer";

export function useOLAPTransformer(
  options: OLAPTransformerOptions | null,
  query: OLAPTransformerQuery,
): OLAPTransformerResult | null {
  const instance = useMemo(() => (options ? new OLAPTransformer(options) : null), [options]);
  const [data, setData] = useState<OLAPTransformerResult | null>(null);
  useEffect(() => {
    (async () => {
      if (instance) {
        const payload = await instance.getData(query);
        setData(payload);
      } else {
        setData(null);
      }
    })();
  }, [query, instance]);

  return data;
}
